import GalleryNote from "./GalleryNote";

export default GalleryNote;
